













































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    props: {
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: false
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        tooltipText: {
            type: String,
            required: false,
            default: "",
        },
        maxLength: {
            type: Number,
            required: false,
            default: -1
        },
        inputId: {
            type: String,
            required: true
        },
        inputLabel: {
            type: String,
            required: false,
            default: ""
        },
        inputDescription: {
            type: String,
            required: false,
            default: ""
        },
        ariaLabelledby: {
            required: false,
            type: String,
            default: "",
        },
        ariaInvalid: {
            type: Boolean,
            required: false,
            default: false,
        },
        defaultText: {
            type: String,
            required: false,
            default: ""
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        isVisible: {
            type: Boolean,
            required: false,
            default: true
        },
        name: {
            type: String,
            required: false,
            default: ""
        },
        dataLabel: {
            type: String,
            required: false,
            default: ""
        },
        lang: {
            type: String,
            required: false,
            default: "en",
        },
        fieldStyle: {
            type: String,
            required: false,
            default: ""
        },
        inputStyle: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        }
    },
    data: function() {
        return {
            uniqueId: (this.specificId != "") ? this.specificId : uuidv4(),
            text: this.defaultText as string,
            textareaHeight: 0 as number,
            currentLocale: Trans.currentLocale ?? "en",
        };
    },
    computed: {
        remainingCharacters: function (): number {
            if (this.text) {
                return this.maxLength - this.text.length;
            } else {
                return this.maxLength;
            }
        },
    },
    watch: {
        defaultText: function (newText) {
            this.text = newText;

            // Wait for DOM update
            Vue.nextTick().then(() => { this.resize(); });
        },
        text: function (newText) {
            // Remove HTML
            this.text = (newText ?? "").replace(/(<([^>]+)>)/ig, "");
        }
    },
    mounted: function() {
        if(this.text !== undefined && this.text.length > 0) {
            // Launch resize method when component mount to make sure the correct size is applies if message already has a value
            this.resize();
        }
    },
    methods: {
        /**
         * [resize Resize text area based on content]
         */
        /* istanbul ignore resize */
        resize: function () {
            const textarea = document.getElementById(this.inputId);
            if(textarea) {
                // Resize textarea base on scrollHeight and heightOffset of the textarea
                this.textareaHeight = textarea.scrollHeight;
            }
        },
        updateText: function () {
            this.$emit("update-value", this.text);
        },
        emitLiveValue: function () {
            this.$emit("live-value", this.text);
        },
        reset: function(value: string) {
            this.text = value;
        }
    }
});
